import React from 'react';
import { Navigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { ImportIconBadge } from '@/components/icons/ImportIconBadge';
import { ClientIcon } from '@/components/icons/Client';
import { ClientsImportPage } from './ClientsImportPage';

export const clientsRoutes = [
	{
		// In the side nav's Import section (clientsNavItem)
		path: 'import/clients',
		element: <ClientsImportPage />,
		handle: {
			title: 'Import clients',
			// The side nav's icon (with the import arrow), at the header's size
			icon: (
				<ImportIconBadge>
					<ClientIcon width='40px' height='40px' bgColor='transparent' color='currentColor' />
				</ImportIconBadge>
			),
		},
	},
	{
		// The page's old address
		path: 'clients/import',
		element: <Navigate to={`${paths.admin}/import/clients`} replace />,
	},
];

export const clientsNavItem = {
	text: 'Clients',
	icon: (
		<ImportIconBadge>
			<ClientIcon width='30px' height='30px' bgColor='transparent' sx={{ ml: '-3px' }} />
		</ImportIconBadge>
	),
	link: `${paths.admin}/import/clients`,
};
